import React, { PropTypes } from 'react';
import { ListItem, SimpleListItem } from '../';

const GlossaryDetail = ({ search, searchTerms, terms }) =>
  search.length
    ? <SimpleListItem items={searchTerms} />
    : <div className="col-xs-12">
        {terms.map((item, index) => <ListItem key={index} {...item} />)}
      </div>;

GlossaryDetail.defaultProps = {
  searchTerms: [],
  terms: []
};

const termValidation = {
  term: PropTypes.string.isRequired,
  letter: PropTypes.string.isRequired,
  definition: PropTypes.string.isRequired,
  subitems: PropTypes.object
};

GlossaryDetail.propTypes = {
  search: PropTypes.string.isRequired,
  searchTerms: PropTypes.arrayOf(PropTypes.shape(termValidation)),
  terms: PropTypes.arrayOf(PropTypes.shape(termValidation))
};

export default GlossaryDetail;



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/components/GlossaryDetail/GlossaryDetail.js